import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { join, isArray, reject, fill } from 'lodash';
import { useQuery, useMutation } from '@apollo/client';
import { PAGE_DATA, UPDATE_PAGE_DATA, SET_CLIENT_STATE } from '../../../graphqls';

export default function ListEditor() {
  const { loading, data = {} } = useQuery(PAGE_DATA);
  const [setState] = useMutation(SET_CLIENT_STATE);
  const [updatePageData] = useMutation(UPDATE_PAGE_DATA);
  const [title, setTitle] = useState('');
  const [feed, setMarquees] = useState([]);

  useEffect(() => {
    if (isArray(data.pageData.cache.newsFeed.feed)) {
      setMarquees(data.pageData.cache.newsFeed.feed);
      setTitle(data.pageData.cache.newsFeed.title);
    }
  }, [data]);

  if (loading) {
    return '';
  }

  const onAdd = () => setMarquees([...feed, '']);
  const onRemove = ({
    currentTarget: {
      dataset: { index },
    },
  }) => setMarquees(reject(feed, (_, id) => id === Number(index)));
  const onChange = ({ target: { value } }) => setTitle(value);
  const onFeedChange = ({
    target: {
      dataset: { index },
      value,
    },
  }) => setMarquees(fill([...feed], value, index, index + 1));
  const onSubmit = () => {
    updatePageData({ variables: { cache: { newsFeed: { feed, title } } } });
    setState({ variables: { modalTypeShown: '' } });
  };

  return (
    <div className="news-feed-settings">
      <div className="form-group">
        <label htmlFor="news-feed-label">
          Title
          <span className="little-note">Maximum characters is 50</span>
        </label>
        <input id="news-label" maxLength="50" className="form-control form-control-news-label" value={title} onChange={onChange} />
      </div>
      <div className="form-group marquee-form">
        <label htmlFor="news-feed-input-0">
          Feed
          <span className="little-note">
            Maximum characters per feed is 150. To turn text into a hypertext, follow the format: [your text here](full url here, eg:
            https://your-url.com)
          </span>
        </label>
        {feed.map((marquee, index) => (
          <div className="form-group marquee" key={`${['news', 'feed', index].join('-')}`}>
            {feed.length > 1 && (
              <button type="button" data-index={index} onClick={onRemove}>
                <FontAwesomeIcon icon={['fal', 'times']} />
              </button>
            )}
            <input
              id={join(['news', 'feed', 'input', index], '-')}
              className="form-control"
              data-index={index}
              onChange={onFeedChange}
              value={marquee}
              maxLength="150"
            />
          </div>
        ))}
      </div>
      {feed.length < 10 && (
        <button type="button" className="add-news-btn" onClick={onAdd}>
          + Add Feed
        </button>
      )}
      <div className="button-container">
        <button type="button" className="btn mint-btn" onClick={onSubmit}>
          Submit
        </button>
      </div>
    </div>
  );
}
